import React from "react";

import {
  errorForm,
  fireNewRelicErrorEvent,
} from "@origin-digital/reporting-client";
import { Card, Section, Vertical } from "@origin-digital/layout";
import { ErrorMessage } from "@origin-digital/messages";

import content from "./content.json";

interface IState {
  error?: Error;
}

export class ErrorWrapper extends React.PureComponent<{}, IState> {
  public state: IState = {};

  public componentDidCatch(error: Error) {
    fireNewRelicErrorEvent(error);
    errorForm({
      errorCode: error.name,
      errorMessage: error.message,
    });
    this.setState({ error });
  }

  public render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <Section layoutSize="compact" data-id="staticpages-error">
          <Vertical>
            <Card fullWidth>
              <ErrorMessage heading={content.heading} text={content.text} />
            </Card>
          </Vertical>
        </Section>
      );
    }

    return children;
  }
}
